import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import ChatsIndex from './components/modules/chats/Index.vue'
import Admin from './components/modules/chats/Admin.vue'
import History from './components/modules/chats/History.vue'
// import ServersIndex from './components/modules/servers/Index.vue'
import ServersData from './components/modules/servers/Data.vue'
import SQL from './components/modules/dashboard/SQL.vue'
import DashboardHome from './components/modules/dashboard/dashboard.vue'
import NotFound from './components/modules/dashboard/404.vue'
import Users from './components/modules/users/Index.vue'
import AllInfo from './components/modules/users/All-Info.vue'
import FBUsers from './components/modules/users/facebook.vue'
import Skins from './components/modules/skins/Index.vue'
import Pending from './components/modules/skins/Pending.vue'
import Analytic from './components/modules/analytic/index.vue'
import NonAnalytic from './components/modules/analytic/NonAnalytic.vue'
import Waiting from './components/modules/skins/Waiting.vue'
import Private from './components/modules/skins/Private.vue'
import PrivateWaiting from './components/modules/skins/Private-Waiting.vue'
import Ban from './components/modules/ban/Index.vue'
import Coins from './components/modules/coins/Index.vue'
import Rewards from './components/modules/coins/Rewards.vue'

// Routes
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      document.body.className = 'login-page'
      next()
    }
  }, {
    path: '/',
    component: Dashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      document.body.className += ' skin-blue sidebar-mini'
      next()
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
        // alert('test')
      })
    },
    children: [
      {
        path: '',
        redirect: '/skins-managment'
      }, {
        path: '/chats',
        name: 'chats',
        component: ChatsIndex
      }, {
        path: '/chats/history',
        name: 'history',
        component: History
      },
      // {
      //   path: '/servers',
      //   name: 'servers',
      //   component: ServersIndex
      // },
      {
        path: '/servers-data',
        name: 'serversData',
        component: ServersData
      }, {
        path: '/users',
        name: 'users',
        component: Users
      }, {
        path: '/all-info',
        name: 'allInfo',
        component: AllInfo
      }, {
        path: '/analytic',
        name: 'analytic',
        component: Analytic
      }, {
        path: '/block-analytics',
        name: 'NonAnalytic',
        component: NonAnalytic
      }, {
        path: '/facebook-switch',
        name: 'fbusers',
        component: FBUsers
      }, {
        path: '/skins',
        name: 'skins',
        component: Skins
      }, {
        path: '/skins-managment',
        name: 'waiting',
        component: Waiting
      }, {
        path: '/private-skins',
        name: 'private',
        component: Private
      }, {
        path: '/ban',
        name: 'Ban',
        component: Ban
      }, {
        path: '/coins',
        name: 'Coins',
        component: Coins
      }, {
        path: '/private-skins-managment',
        name: 'privateWaiting',
        component: PrivateWaiting
      }, {
        path: '/pending-skins',
        name: 'Pending',
        component: Pending
      }, {
        path: '/dashboard',
        name: 'dashboardHome',
        component: DashboardHome
      }, {
        path: '/rewards',
        name: 'Rewards',
        component: Rewards
      }, {
        path: '/admin-chat',
        name: 'Admin',
        component: Admin
      }, {
        path: '/sql',
        name: 'SQL',
        component: SQL
      }, {
        path: '*',
        name: '404',
        component: NotFound
      }
    ]
  }, {
    // not found handler
    path: '*',
    redirect: '/login'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js